<template>
  <div class="board-wrapper">
    <div class="board-wrapper_scroll">
      <div>
        <dv-scroll-board
          :config="config"
          style="height: 36px; background-color: none"
        />
      </div>
    </div>
    <!-- <span class="time">{{ time }}</span> -->
  </div>
</template>
<script>
import { getWasteTypeTopList } from '@/API/price/price.js';
export default {
  name: 'boardIndex',
  data() {
    return {
      config: {
        data: [],
        rowNum: 1,
        waitTime: 2000,
        columnWidth: [70, 40, 100, 70, 150],
        oddRowBGC: 'none',
        evenRowBGC: 'none',
      },
      time: '',
    };
  },
  created() {
    this.updateTime();
    console.log('获取子类价格1', this.config.data);
    this.timer = setInterval(this.updateTime, 1000);
    getWasteTypeTopList().then((res) => {
      if (res.code == 200) {
        if (res.data && res.data.length) {
          let tempData = [];
          res.data.forEach((item) => {
            let str = '';
            let color = 'rgb(106, 112, 112)';
            if(item.growthRatio > 0){
              str = '⬆';
              color = 'red';
            }else if(item.growthRatio < 0){
              str = '⬇';
              color= "green"
            }
            tempData.push([
              `<span style="color:rgb(68, 98, 197)">${item.wasteName}</span>`,
              '<i class="el-icon-s-data" style="color: rgb(0, 195, 255)" />',
              `${item.price} ${item.unit}`,
              `<span style="color:${color}">${Math.abs(item.growthRatio)} ${str}</span>`,
              `<span style="color:rgb(106, 112, 112);font-size: 14px;font-weight: 400;">${item.priceDate}</span>`,
            ]);
          });
          this.config = {
            data:tempData,
            rowNum: 1,
            waitTime: 2000,
            columnWidth: [70, 40, 120, 90, 120],
            oddRowBGC: 'none',
            evenRowBGC: 'none',
          };
        }
      }
      console.log('获取子类价格', res, this.config.data);
    });
  },
  methods: {
    updateTime() {
      const date = new Date();
      const formatter = new Intl.DateTimeFormat('zh-CN', {
        // year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // 使用24小时制
      });

      this.time = formatter.format(date);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="less">
.board-wrapper {
  user-select: none;
  display: flex;
  align-items: center;
  .board-wrapper_scroll {
    // border-top: 0.5px solid #00000010;
    // border-bottom: 0.5px solid #00000010;
    background-color: #ffffff;
    ::v-deep .rows {
      .row-item {
        color: rgb(0, 0, 0);
      }
    }
  }
  .time {
    margin-left: 10px;
    font-size: 14px;
    color: rgb(106, 112, 112);
    font-weight: 400;
  }
}
</style>
